module.exports = __webpack_public_path__ + "static/media/JM.30f2e33c.png";